import { IonIcon, IonModal } from '@ionic/react';
import { arrowForwardOutline, bookOutline, settingsOutline, storefrontOutline } from 'ionicons/icons';
import React from 'react';
import ModalHeader from '../Modal/ModalHeader';
import './WelcomeModal.css';

type WelcomeModalProps = {
    isOpen: boolean;
    onClose: () => void;
    onStart: () => void;
};

const WelcomeModal: React.FC<WelcomeModalProps> = ({ isOpen, onClose, onStart }) => (
    <IonModal className="xeguei-dialog onboarding-welcome-modal" isOpen={isOpen} onDidDismiss={onClose}>
        <div className="xeguei-dialog-panel">
            <ModalHeader title="Bem-vindo ao Xeguei!" subtitle="Vamos preparar sua loja para começar a vender." icon={storefrontOutline} layout="compact" onDismiss={onClose} />
            <div className="xeguei-dialog-body welcome-modal-content">
                <p className="welcome-modal-intro">Um passo de cada vez. Vamos ajudar você a configurar:</p>
                <ul className="welcome-modal-steps">
                    <li><span className="welcome-step-icon"><IonIcon icon={storefrontOutline} aria-hidden="true" /></span><div><strong>Seu estabelecimento</strong><p>Dados da loja e horários de funcionamento.</p></div></li>
                    <li><span className="welcome-step-icon"><IonIcon icon={bookOutline} aria-hidden="true" /></span><div><strong>Seu cardápio</strong><p>Produtos e formas de pagamento.</p></div></li>
                    <li><span className="welcome-step-icon"><IonIcon icon={settingsOutline} aria-hidden="true" /></span><div><strong>Sua operação</strong><p>Entrega, WhatsApp e impressão.</p></div></li>
                </ul>
                <p className="welcome-modal-note">Você pode sair e continuar a configuração depois.</p>
            </div>
            <footer className="xeguei-dialog-footer welcome-modal-footer">
                <button type="button" className="xeguei-modal-primary" onClick={onStart}>Configurar minha loja<IonIcon icon={arrowForwardOutline} aria-hidden="true" /></button>
            </footer>
        </div>
    </IonModal>
);

export default WelcomeModal;
